import React from "react";
import {
  TextField,
  Box,
  MenuItem,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Titulo from "../Titulo";
import ButtonTypeName from "../ButtonTypeName";

const statusOption = [
  {
    key: 1,
    value: true,
    label: "Ativa",
  },
  {
    key: 2,
    value: false,
    label: "Inativa",
  },
];

function ItensPesquisa({ actionPesquisa }) {
  const [precadastro, setPreCadastro] = React.useState(null);
  const [nomeFantasia, setNomeFantasia] = React.useState(null);
  const [cnpj, setCNPJ] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [sigla, setSigla] = React.useState(null);
  const [interno, setInterno] = React.useState(null);
  const [externo, setExterno] = React.useState(null);

  const handleChange = (event) => {
    setPreCadastro(event.target.checked);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChangeInterno = (event) => {
    setInterno(event.target.checked);
  };

  const handleChangeExterno = (event) => {
    setExterno(event.target.checked);
  };

  const pesquisar = () => {
      const objPesquisa = {
          nomeFantasia: nomeFantasia,
          cnpj: cnpj,
          interno: interno,
          externo: externo,
          precadastro: precadastro,
          status: status,
          sigla: sigla
      }

      actionPesquisa(objPesquisa);
  }

  return (
    <>
      <Titulo titulo="Filtro de Pesquisa" />
      <Divider />
      <Box
        component="form"
        sx={{
          width: "250px",
        }}
        padding={4}
        className="form-pesquisa"
        spacing={2}
        noValidate
        autoComplete="off"
      >
        <TextField id="nomeFantasia" label="Nome Fantasia" value={nomeFantasia} onChange={(e) => setNomeFantasia(e.target.value)}/>
        <TextField id="cnpj" label="CNPJ" value={cnpj} onChangeCapture={(e) => setCNPJ(e.target.value)} />
        <TextField
          id="status"
          select
          label="Status"
          value={status}
          onChange={handleChangeStatus}
        >
          {statusOption.map((status) => (
            <MenuItem key={status.key} value={status.value}>
              {status.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField id="sigla" label="Sigla" value={sigla} onChangeCapture={(e) => setSigla(e.target.value)} />
        <FormControlLabel
                  style={{ width: "100%" }}
                  id="preCadastro"
                  label="Exige pré-cadastro para realizar pagamento online"
                  control={
                    <Checkbox checked={precadastro} onChange={handleChange} />
                  }
                />
        <FormControlLabel
          control={
            <Checkbox
              name="Interno"
              checked={interno}
              onChange={(e) => handleChangeInterno(e)}
            />
          }
          label="Checkout Interno"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="Externo"
              checked={externo}
              onChange={handleChangeExterno}
            />
          }
          label="Checkout Externo"
        />

      </Box>
      <div className="button-pesquisa">
        <ButtonTypeName onClick={() => pesquisar()} typeButton={17} />
      </div>
    </>
  );
}

export default ItensPesquisa;
